/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AssignProductSeatRequest} from '../models/AssignProductSeatRequest';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {ProductSeatUpdateResult} from '../models/ProductSeatUpdateResult';

export interface AssignProductSeatBulk$Request {
    assignProductSeatRequest: AssignProductSeatRequest;
    reason?: string;
}

export interface AssignProductSeatBulk$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const assignProductSeatBulkRequest = createAction<PayloadData<void, AssignProductSeatBulk$Request>>('BULK_PRODUCT_SEAT_ASSIGNMENT__ASSIGN_PRODUCT_SEAT_BULK__REQUEST');
export const assignProductSeatBulkSuccess = createAction<PayloadData<string, AssignProductSeatBulk$Request>>('BULK_PRODUCT_SEAT_ASSIGNMENT__ASSIGN_PRODUCT_SEAT_BULK__SUCCESS');
export const assignProductSeatBulkFailure = createAction<PayloadData<Error, AssignProductSeatBulk$Request, true>>('BULK_PRODUCT_SEAT_ASSIGNMENT__ASSIGN_PRODUCT_SEAT_BULK__FAILURE');

export const assignProductSeatBulkActions = [
    assignProductSeatBulkRequest,
    assignProductSeatBulkSuccess,
    assignProductSeatBulkFailure
] as const;

/**
 * @param {AssignProductSeatRequest} meta.assignProductSeatRequest
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const assignProductSeatBulk = (meta: AssignProductSeatBulk$Request, config?: AssignProductSeatBulk$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: assignProductSeatBulkActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/bulk-actions/users/product-seats`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.assignProductSeatRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetProductSeatBulkProgress$Request {
    id: string;
}

export interface GetProductSeatBulkProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProductSeatBulkProgressRequest = createAction<PayloadData<void, GetProductSeatBulkProgress$Request>>('BULK_PRODUCT_SEAT_ASSIGNMENT__GET_PRODUCT_SEAT_BULK_PROGRESS__REQUEST');
export const getProductSeatBulkProgressSuccess = createAction<PayloadData<BulkProgress, GetProductSeatBulkProgress$Request>>('BULK_PRODUCT_SEAT_ASSIGNMENT__GET_PRODUCT_SEAT_BULK_PROGRESS__SUCCESS');
export const getProductSeatBulkProgressFailure = createAction<PayloadData<Error, GetProductSeatBulkProgress$Request, true>>('BULK_PRODUCT_SEAT_ASSIGNMENT__GET_PRODUCT_SEAT_BULK_PROGRESS__FAILURE');

export const getProductSeatBulkProgressActions = [
    getProductSeatBulkProgressRequest,
    getProductSeatBulkProgressSuccess,
    getProductSeatBulkProgressFailure
] as const;

/**
 * @param {string} meta.id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProductSeatBulkProgress = (meta: GetProductSeatBulkProgress$Request, config?: GetProductSeatBulkProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getProductSeatBulkProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/product-seats/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetProductSeatBulkResult$Request {
    id: string;
}

export interface GetProductSeatBulkResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProductSeatBulkResultRequest = createAction<PayloadData<void, GetProductSeatBulkResult$Request>>('BULK_PRODUCT_SEAT_ASSIGNMENT__GET_PRODUCT_SEAT_BULK_RESULT__REQUEST');
export const getProductSeatBulkResultSuccess = createAction<PayloadData<ProductSeatUpdateResult, GetProductSeatBulkResult$Request>>('BULK_PRODUCT_SEAT_ASSIGNMENT__GET_PRODUCT_SEAT_BULK_RESULT__SUCCESS');
export const getProductSeatBulkResultFailure = createAction<PayloadData<Error, GetProductSeatBulkResult$Request, true>>('BULK_PRODUCT_SEAT_ASSIGNMENT__GET_PRODUCT_SEAT_BULK_RESULT__FAILURE');

export const getProductSeatBulkResultActions = [
    getProductSeatBulkResultRequest,
    getProductSeatBulkResultSuccess,
    getProductSeatBulkResultFailure
] as const;

/**
 * @param {string} meta.id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProductSeatBulkResult = (meta: GetProductSeatBulkResult$Request, config?: GetProductSeatBulkResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getProductSeatBulkResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/product-seats`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopProductSeatBulk$Request {
    id: string;
}

export interface StopProductSeatBulk$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopProductSeatBulkRequest = createAction<PayloadData<void, StopProductSeatBulk$Request>>('BULK_PRODUCT_SEAT_ASSIGNMENT__STOP_PRODUCT_SEAT_BULK__REQUEST');
export const stopProductSeatBulkSuccess = createAction<PayloadData<void, StopProductSeatBulk$Request>>('BULK_PRODUCT_SEAT_ASSIGNMENT__STOP_PRODUCT_SEAT_BULK__SUCCESS');
export const stopProductSeatBulkFailure = createAction<PayloadData<Error, StopProductSeatBulk$Request, true>>('BULK_PRODUCT_SEAT_ASSIGNMENT__STOP_PRODUCT_SEAT_BULK__FAILURE');

export const stopProductSeatBulkActions = [
    stopProductSeatBulkRequest,
    stopProductSeatBulkSuccess,
    stopProductSeatBulkFailure
] as const;

/**
 * @param {string} meta.id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopProductSeatBulk = (meta: StopProductSeatBulk$Request, config?: StopProductSeatBulk$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopProductSeatBulkActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/users/product-seats`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

